import React, { useState, useEffect } from 'react';

const EXPERIENCES = [
  {
    id: 'indie',
    title: 'Game Developer / Technical Designer',
    company: 'Indie Game Project',
    companyUrl: 'https://drive.google.com/file/d/1urLqpVj23kzkLcwQWQOFqxSu_jrs5H1i/view?usp=drive_link',
    timelineEn: 'Independent project with friends / Ukraine',
    timelineUa: 'Незалежний проєкт з друзями / Україна',
    quickBullets: [
      { en: 'Game development (C++ / Blueprints)', ua: 'Розробка гри (C++ / Blueprints)' },
      { en: 'Technical design', ua: 'Технічний дизайн' },
      { en: 'Polishing before publisher pitch', ua: 'Полірування перед презентацією видавцям' },
    ],
    roleEn:
      'Working as Game Developer and Technical Designer in a small team of friends on an indie game built with C++ and Blueprints. The game is currently in the polishing stage and is being prepared to be sent to publishers.',
    roleUa:
      'Працюю як розробник ігор та технічний дизайнер у невеликій команді друзів над інді-грою на C++ та Blueprints. Наразі гра на етапі полірування та готується до відправки видавцям.',
    projects: [
      {
        name: 'Indie Game - Download Playable Build',
        link: 'https://drive.google.com/file/d/1urLqpVj23kzkLcwQWQOFqxSu_jrs5H1i/view?usp=drive_link',
        descEn:
          'A playable build of the game is available for download. Responsible for gameplay development and technical design in C++ and Blueprints.',
        descUa:
          'Ігрова збірка доступна для завантаження. Відповідальний за розробку геймплею та технічний дизайн на C++ та Blueprints.',
        tags: ['C++', 'Blueprints', 'Indie', 'Technical Design'],
      },
    ],
    highlights: [
      {
        en: 'Game reached the polishing stage and will be sent to publishers for further steps.',
        ua: 'Гра дійшла до етапу полірування і буде відправлена видавцям для подальших кроків.',
      },
    ],
  },
  {
    id: 'zsu',
    title: 'Engineer',
    company: 'Ukrainian Armed Forces',
    companyUrl: 'https://mod.gov.ua/en',
    timelineEn: 'March 2025 - until now / Ukraine',
    timelineUa: 'Березень 2025 - до тепер / Україна',
    quickBullets: [
      { en: 'Create app', ua: 'Створення додатку' },
      { en: 'ML TensorFlow', ua: 'ML TensorFlow' },
      { en: 'Product owner', ua: 'Управління проектами' },
      { en: 'Tech documentation', ua: 'Технічна документація' },
    ],
    roleEn:
      'Leading the architecture, end-to-end development, and deployment of specialized mobile and tactical software solutions. Acting as Product Owner to gather mission-critical operational requirements, define user stories, and coordinate field testing under strict reliability constraints.',
    roleUa:
      'Керівництво архітектурою, повною розробкою та впровадженням спеціалізованих мобільних і тактичних програмних рішень. Роль Product Owner: збір критично важливих операційних вимог, формування беклогу завдань та координація польового тестування в умовах підвищеної надійності.',
    projects: [
      {
        name: 'Tactical Mobile Application',
        descEn:
          'Architecture and development of an offline-first mobile calculation and situational utility designed for field operators operating under high electronic interference.',
        descUa:
          'Архітектура та розробка автономного мобільного застосунку для оперативних розрахунків та ситуаційної обізнаності в умовах радіоелектронних завад.',
        tags: ['Mobile Development', 'Offline Sync', 'Product Ownership', 'UI/UX'],
      },
      {
        name: 'On-Device Computer Vision & ML (TensorFlow)',
        descEn:
          'Integration and optimization of lightweight computer vision and machine learning models for real-time edge processing and object detection on resource-constrained devices.',
        descUa:
          'Інтеграція та оптимізація легкої моделі комп’ютерного зору (TensorFlow) для розпізнавання та детекції об’єктів у реальному часі на мобільних пристроях.',
        tags: ['TensorFlow', 'Computer Vision', 'Edge AI', 'Python'],
      },
    ],
    highlights: [
      {
        en: 'Successfully designed, built, and deployed stable field software currently utilized in active operational scenarios.',
        ua: 'Розробив та впровадив стабільне програмне забезпечення, що успішно використовується в реальних операційних умовах.',
      },
      {
        en: 'Engineered robust on-device ML inference pipeline without reliance on cloud or external connectivity.',
        ua: 'Побудував автономний пайплайн роботи ML-моделей на пристрої без залежності від хмарних сервісів чи інтернету.',
      },
      {
        en: 'Authored comprehensive technical architecture documentation, user manuals, and training materials.',
        ua: 'Склав вичерпну технічну документацію, архітектурні схеми та інструкції для операторів.',
      },
    ],
  },
  {
    id: 'taf-drones',
    title: 'Research Engineer',
    company: 'TAF Drones',
    companyUrl: 'https://www.tafdrones.com/en',
    timelineEn: 'December 2024 - December 2025 / Ukraine, Kyiv',
    timelineUa: 'Грудень 2024 - Грудень 2025 / Україна, Київ',
    quickBullets: [
      { en: 'Drone simulation', ua: 'Симуляція дронів в штучному середовищі' },
      { en: 'Gazebo / ROS2 / PX4 / Betaflight', ua: 'Gazebo / ROS2 / PX4 / Betaflight' },
      { en: 'Write Technical Documentation', ua: 'Написання технічної документації' },
    ],
    roleEn:
      'Researching and developing high-fidelity synthetic physics simulation pipelines for unmanned aerial vehicles (UAVs). Bridged flight control firmware with virtual simulation environments to validate autonomous behaviors and aerodynamic performance prior to field trials.',
    roleUa:
      'Дослідження та створення високоточних симуляцій фізики БПЛА та автономних платформ. Інтеграція польотних контролерів з віртуальними фізичними середовищами для безпечної валідації алгоритмів польоту перед польовими випробуваннями.',
    projects: [
      {
        name: 'Synthetic UAV Physics & Environment Simulation',
        descEn:
          'Constructed realistic multirotor simulation environments in Gazebo and ROS2 with accurate aerodynamics, sensor noise (IMU, optical flow, GPS-denied conditions), and custom environmental dynamics.',
        descUa:
          'Створення деталізованих моделей дронів та симуляційного простору в Gazebo та ROS2 з урахуванням аеродинаміки, шумів сенсорів та сценаріїв радіоелектронного придушення.',
        tags: ['ROS2', 'Gazebo', 'Physics Modeling', 'C++', 'Python'],
      },
      {
        name: 'Autopilot SITL & HITL Integration',
        descEn:
          'Configured Software-In-The-Loop (SITL) and Hardware-In-The-Loop (HITL) testbenches for PX4 and Betaflight stacks, enabling rapid automated regression testing of flight logic.',
        descUa:
          'Налаштування стендів SITL та HITL для прошивок PX4 та Betaflight, що забезпечило швидке автоматизоване тестування польотної логіки без ризику для апаратних прототипів.',
        tags: ['PX4', 'Betaflight', 'SITL / HITL', 'MAVLink', 'Linux'],
      },
    ],
    highlights: [
      {
        en: 'Significantly lowered hardware crash rates during field tests by catching firmware edge cases in virtual environments.',
        ua: 'Знизив ризик пошкодження прототипів під час польових тестів завдяки завчасному виявленню крайових випадків у симуляторі.',
      },
      {
        en: 'Authored step-by-step engineering guidelines and technical documentation for flight simulation and sensor calibration.',
        ua: 'Підготував вичерпні інженерні інструкції з налаштування симулятора та калібрування сенсорів.',
      },
    ],
  },
  {
    id: 'pcf',
    title: 'Senior Technical Designer - Feature Owner',
    company: 'People Can Fly',
    companyUrl: 'https://peoplecanfly.com/',
    timelineEn: 'August 2024 - May 2025 / Ukraine, Kyiv',
    timelineUa: 'Серпень 2024 - Травень 2025 / Україна, Київ',
    quickBullets: [
      { en: 'Feature management', ua: 'Управління основними механіками' },
      { en: 'UE5 gameplay prototyping (C++/Blueprint)', ua: 'Розробка в рушії Unreal Engine 5' },
      { en: 'Write GDD', ua: 'Написання документації' },
    ],
    roleEn:
      'Served as Feature Owner for core gameplay mechanics on an unannounced AAA Unreal Engine 5 project. Acted as the technical link between game design, animation, and core engineering departments to ensure high-fidelity implementation and optimal performance.',
    roleUa:
      'Працював як Feature Owner ключових геймплейних механік на неанонсованому AAA action-проєкті на рушії Unreal Engine 5. Забезпечував технічний зв’язок між дизайнерами, аніматорами та програмістами геймплею.',
    projects: [
      {
        name: 'Unannounced AAA Action Title (UE5)',
        descEn:
          'Led design and technical prototyping for primary combat and player locomotion mechanics, developing functional whitebox prototypes in C++ and Blueprints.',
        descUa:
          'Керував дизайном та прототипуванням бойових механік і переміщення гравця, створюючи швидкі функціональні прототипи на базі C++ та Blueprints.',
        tags: ['Unreal Engine 5', 'C++', 'Blueprints', 'Feature Ownership', 'Systems Design'],
      },
      {
        name: 'Technical Design Documentation (GDD)',
        descEn:
          'Authored detailed Game Design Documents defining state machines, mathematical damage models, edge cases, and performance constraints.',
        descUa:
          'Створював детальну технічну документацію (GDD) з алгоритмічним описом поведінки систем, граничними станами та вимогами до оптимізації.',
        tags: ['GDD', 'Confluence', 'Jira', 'Perforce'],
      },
    ],
    highlights: [
      {
        en: 'Delivered robust gameplay prototypes that validated combat feel and technical viability for production approval.',
        ua: 'Створив якісні геймплейні прототипи, які підтвердили динаміку гри та технічну життєздатність для переходу у фазу продакшену.',
      },
      {
        en: 'Standardized feature prototyping pipelines and cross-departmental review criteria in Unreal Engine 5.',
        ua: 'Стандартизував процеси прототипування фіч та міжкомандного рев’ю в Unreal Engine 5.',
      },
    ],
  },
  {
    id: '4a-games',
    title: 'Senior Technical Designer - Project Manager',
    company: '4A Games',
    companyUrl: 'https://www.4a-games.com.ua/',
    timelineEn: 'August 2023 - August 2024 / Ukraine, Kyiv',
    timelineUa: 'Серпень 2023 - Серпень 2024 / Україна, Київ',
    quickBullets: [
      { en: 'Feature management', ua: 'Управління основними механіками' },
      { en: 'Write GDD', ua: 'Написання документації' },
      { en: 'UE5 gameplay prototyping (C++/Blueprint)', ua: 'Розробка в рушії Unreal Engine 5' },
    ],
    roleEn:
      'Combined senior technical game design with project management responsibilities. Drove core systems development, coordinated sprint roadmaps, mitigated technical bottlenecks, and aligned multi-disciplinary teams in Unreal Engine 5.',
    roleUa:
      'Поєднував обов’язки сеньйор технічного дизайнера та проектного менеджера: проектування ігрових систем, ведення дорожніх карт спринтів та усунення технічних блокерів між командами на Unreal Engine 5.',
    projects: [
      {
        name: 'Next-Gen Gameplay Mechanics & Interactive Systems',
        descEn:
          'Prototyped weapon behavior, immersive environmental interactions, and reactive game mechanics using UE5 Blueprints and C++ within stringent CPU/GPU budgets.',
        descUa:
          'Проектував та прототипував поведінку зброї, інтерактивні механіки оточення та системну взаємодію в UE5 (C++ та Blueprints) з урахуванням суворих лімітів продуктивності.',
        tags: ['Unreal Engine 5', 'C++', 'Blueprints', 'Gameplay Systems'],
      },
      {
        name: 'Sprint & Production Pipeline Management',
        descEn:
          'Organized agile sprints, decomposed technical requirements, prioritized backlog items, and maintained transparent cross-team dependencies in Jira/YouTrack.',
        descUa:
          'Організовував спринти, декомпонував технічні завдання, пріоритизував беклог та забезпечував прозорість залежностей у Jira/YouTrack.',
        tags: ['Project Management', 'Agile / Scrum', 'Jira', 'YouTrack'],
      },
    ],
    highlights: [
      {
        en: 'Delivered high-performance technical prototypes that defined core systems architecture.',
        ua: 'Створив високопродуктивні прототипи систем, що визначили базову архітектуру механік.',
      },
      {
        en: 'Achieved consistent on-time milestone delivery by streamlining task dependencies between programmers and artists.',
        ua: 'Забезпечив своєчасну здачу майлстоунів завдяки ефективному плануванню завдань між програмістами та художниками.',
      },
    ],
  },
  {
    id: 'dreamate-lead',
    title: 'Lead Game Designer - Project Manager',
    company: 'Dreamate',
    companyUrl: 'https://dreamate.games/',
    timelineEn: 'January 2022 - July 2023 / Ukraine, Kyiv',
    timelineUa: 'Січень 2022 - Липень 2023 / Україна, Київ',
    quickBullets: [
      { en: 'Team management', ua: 'Управління командою' },
      { en: 'Write GDD', ua: 'Написання документації' },
      { en: 'UE5 gameplay prototyping', ua: 'Розробка в рушії Unreal Engine 5' },
    ],
    roleEn:
      'Led the game design department and managed project timelines for "New Arc Line", an ambitious steampunk-fantasy CRPG. Mentored designers, established technical design workflows, and collaborated directly with executive stakeholders and publishers.',
    roleUa:
      'Керував відділом геймдизайну та виробничими графіками проєкту «New Arc Line» (стимпанк-фентезі CRPG). Здійснював менторство дизайнерів, налаштовував технічні процеси розробки та комунікував із керівництвом і видавцем.',
    projects: [
      {
        name: 'New Arc Line (Steam)',
        link: 'https://store.steampowered.com/app/2458310/New_Arc_Line/',
        descEn:
          'Architected core RPG systems: character classes, the magic vs. technology ideological conflict, turn-based combat encounters, status effects, and progression balance in Unreal Engine 5.',
        descUa:
          'Розробка дизайну ключових систем: класів персонажів, протистояння магії та технологій, покрокового тактичного бою, статусних ефектів та балансу спорядження в UE5.',
        tags: ['Unreal Engine 5', 'New Arc Line', 'CRPG', 'Turn-Based Combat', 'Team Leadership'],
      },
    ],
    highlights: [
      {
        en: 'Successfully led the design department through vertical slice production, trailer release, and public Steam announcement.',
        ua: 'Успішно провів команду дизайну через розробку Vertical Slice, реліз трейлера та офіційний анонс гри в Steam.',
      },
      {
        en: 'Established standardized design documentation and rapid UE5 prototyping best practices for the studio.',
        ua: 'Впровадив єдині стандарти дизайн-документації та практики швидкого прототипування в Unreal Engine 5.',
      },
    ],
  },
  {
    id: 'dreamate-gd',
    title: 'Gameplay Designer',
    company: 'Dreamate',
    companyUrl: 'https://dreamate.games/',
    timelineEn: 'September 2021 - January 2022 / Ukraine, Kyiv',
    timelineUa: 'Вересень 2021 - Січень 2022 / Україна, Київ',
    quickBullets: [
      { en: 'Feature management', ua: 'Управління основними механіками' },
      { en: 'Write GDD', ua: 'Написання документації' },
      { en: 'UE5 gameplay prototyping', ua: 'Розробка в рушії Unreal Engine 5' },
    ],
    roleEn:
      'Prototyped foundational gameplay mechanics, tactical movement, ability trees, and interactive dialogue logic for New Arc Line in Unreal Engine.',
    roleUa:
      'Розробка початкових геймплейних механік, тактичного переміщення, дерева вмінь та діалогових систем для New Arc Line в Unreal Engine.',
    projects: [
      {
        name: 'New Arc Line - Combat & World Systems',
        descEn:
          'Built playable prototypes of tactical turn-based grid movement, cover interactions, skill checks, and status modifiers.',
        descUa:
          'Створення інтерактивних прототипів тактичного переміщення, укриттів, перевірки навичок та статусних модифікаторів.',
        tags: ['Unreal Engine 5', 'Prototyping', 'Tactical Grid', 'Game Balance'],
      },
    ],
    highlights: [
      {
        en: 'Constructed working prototypes that proved the viability of turn-based tactical combat.',
        ua: 'Створив діючі прототипи, які підтвердили ефективність тактичної бойової системи.',
      },
    ],
  },
  {
    id: 'wg-lead',
    title: 'Lead Technical Game Designer - Project Manager',
    company: 'Wargaming',
    companyUrl: 'https://na.wargaming.net/en',
    timelineEn: 'September 2020 - September 2021 / Ukraine, Kyiv',
    timelineUa: 'Вересень 2020 - Вересень 2021 / Україна, Київ',
    quickBullets: [
      { en: 'Team management', ua: 'Управління командою' },
      { en: 'Feature management', ua: 'Управління основними механіками' },
      { en: 'Write GDD', ua: 'Написання документації' },
      { en: 'UE4 gameplay prototyping', ua: 'Розробка в рушії Unreal Engine 4' },
    ],
    roleEn:
      'Led the technical game design team on an unannounced vehicle Battle Royale project. Managed the team and feature ownership, wrote design documentation, and prototyped gameplay in Unreal Engine.',
    roleUa:
      'Керував командою технічних дизайнерів на неанонсованому проєкті в жанрі Vehicle Battle Royale. Займався управлінням командою та основними механіками, написанням документації та прототипуванням геймплею в Unreal Engine.',
    projects: [
      {
        name: 'Unannounced Project - Vehicle Battle Royale',
        descEn:
          'Team and feature management, design documentation, and gameplay prototyping in Unreal Engine for an unannounced vehicle-based Battle Royale game.',
        descUa:
          'Управління командою та механіками, написання документації й прототипування геймплею в Unreal Engine для неанонсованої гри Vehicle Battle Royale.',
        tags: ['Unreal Engine', 'Battle Royale', 'Team Leadership', 'GDD'],
      },
    ],
    highlights: [
      {
        en: 'Led a technical design team and owned key gameplay features of an unannounced project.',
        ua: 'Очолював команду технічного дизайну та відповідав за ключові механіки неанонсованого проєкту.',
      },
    ],
  },
  {
    id: 'wg-tech',
    title: 'Technical Game Designer',
    company: 'Wargaming',
    companyUrl: 'https://na.wargaming.net/en',
    timelineEn: 'March 2019 - September 2020 / Ukraine, Kyiv',
    timelineUa: 'Березень 2019 - Вересень 2020 / Україна, Київ',
    quickBullets: [
      { en: 'Feature management', ua: 'Управління основними механіками' },
      { en: 'Write GDD', ua: 'Написання документації' },
      { en: 'UE4 gameplay prototyping', ua: 'Розробка в рушії Unreal Engine 4' },
    ],
    roleEn:
      'Moved from World of Warplanes to an unannounced vehicle Battle Royale project as a Technical Game Designer, implementing and prototyping gameplay features and writing technical design documentation.',
    roleUa:
      'Перейшов зі світу World of Warplanes на неанонсований проєкт Vehicle Battle Royale на посаді технічного геймдизайнера: реалізація та прототипування геймплейних механік, написання технічної документації.',
    projects: [
      {
        name: 'Unannounced Project - Vehicle Battle Royale',
        descEn:
          'Feature management, gameplay prototyping in Unreal Engine, and technical design documentation.',
        descUa:
          'Управління механіками, прототипування геймплею в Unreal Engine та технічна документація.',
        tags: ['Unreal Engine', 'Battle Royale', 'Prototyping', 'GDD'],
      },
    ],
    highlights: [
      {
        en: 'Grew from Game Designer to Technical Game Designer, taking ownership of feature implementation.',
        ua: 'Професійно виріс від геймдизайнера до технічного геймдизайнера, взявши на себе реалізацію механік.',
      },
    ],
  },
  {
    id: 'wg-gd',
    title: 'Game Designer',
    company: 'Wargaming',
    companyUrl: 'https://na.wargaming.net/en',
    timelineEn: 'March 2016 - March 2019 / Ukraine, Kyiv',
    timelineUa: 'Березень 2016 - Березень 2019 / Україна, Київ',
    quickBullets: [
      { en: 'Feature management', ua: 'Управління основними механіками' },
      { en: 'Write GDD', ua: 'Написання документації' },
      { en: 'Unity gameplay prototyping', ua: 'Розробка в рушії Unity' },
    ],
    roleEn:
      'Designed and managed gameplay features for World of Warplanes, wrote design documentation, and built gameplay prototypes in Unity.',
    roleUa:
      'Проєктування та управління ігровими механіками World of Warplanes, написання дизайн-документації та створення геймплейних прототипів у Unity.',
    projects: [
      {
        name: 'World of Warplanes',
        link: 'https://worldofwarplanes.com/',
        descEn:
          'Feature design and management, game design documentation, and gameplay prototyping for the live game.',
        descUa:
          'Проєктування й управління механіками, написання документації та прототипування геймплею для живої гри.',
        tags: ['World of Warplanes', 'Game Design', 'Unity', 'GDD'],
      },
    ],
    highlights: [
      {
        en: 'Shipped gameplay features on World of Warplanes over three years.',
        ua: 'Протягом трьох років реалізовував ігрові механіки у World of Warplanes.',
      },
    ],
  },
  {
    id: 'ers',
    title: 'Game Designer',
    company: 'ERS Game Studios',
    companyUrl: 'https://jobs.dou.ua/companies/ers-game-studios/',
    timelineEn: 'April 2015 - March 2016 / Ukraine, Kyiv',
    timelineUa: 'Квітень 2015 - Березень 2016 / Україна, Київ',
    quickBullets: [
      { en: 'Feature management', ua: 'Управління основними механіками' },
      { en: 'Write GDD', ua: 'Написання документації' },
      { en: 'Unity gameplay prototyping', ua: 'Розробка в рушії Unity' },
    ],
    roleEn:
      'Designed puzzle mechanics, mini-games, and narrative pacing for casual and hidden-object adventure titles. Scripted interactive scenes and authored comprehensive design documents.',
    roleUa:
      'Дизайн головоломок, міні-ігор та темпу сюжетної розповіді для казуальних ігор та квестів. Скриптування інтерактивних сцен та написання дизайн-документів.',
    projects: [
      {
        name: 'Casual Adventure & Puzzle Titles',
        descEn:
          'Crafted logic puzzles, level flow diagrams, mini-game balance, and interactive gameplay scenes in Unity.',
        descUa:
          'Створення логічних загадок, схем переходів між локаціями, балансування міні-ігор та прототипування в Unity.',
        tags: ['Unity', 'Puzzle Design', 'Narrative Design', 'Casual Games'],
      },
    ],
    highlights: [
      {
        en: 'Delivered multiple polished puzzle systems and narrative sequences according to publisher milestones.',
        ua: 'Створив численні відшліфовані пазли та сюжетні сцени відповідно до вимог видавця.',
      },
    ],
  },
  {
    id: 'enixan',
    title: 'Game Designer',
    company: 'Enixan',
    companyUrl: 'https://enixan.com/',
    timelineEn: 'January 2014 - April 2015 / Ukraine, Kyiv',
    timelineUa: 'Січень 2014 - Квітень 2015 / Україна, Київ',
    quickBullets: [
      { en: 'Write GDD', ua: 'Написання документації' },
      { en: 'Game balance', ua: 'Розробка ігрового балансу' },
      { en: 'Economy calculation', ua: 'Розробка ігрової економіки' },
    ],
    roleEn:
      'Specialized in mathematical modeling, resource inflow/outflow balance, in-game monetization, and unit combat stats for social and mobile casual games.',
    roleUa:
      'Розробка математичних моделей ігрової економіки, балансу видобутку ресурсів, монетизації та бойових параметрів юнітів для мобільних та соціальних ігор.',
    projects: [
      {
        name: 'Game Economy & Balancing Models',
        descEn:
          'Constructed detailed spreadsheet models calculating resource inflation, progression curves, timer pacing, and item pricing.',
        descUa:
          'Побудова детальних математичних моделей для розрахунку інфляції ресурсів, темпу прогресії, таймерів та цін у внутрішньоігровому магазині.',
        tags: ['Game Economy', 'Mathematical Modeling', 'Spreadsheets', 'Monetization'],
      },
    ],
    highlights: [
      {
        en: 'Balanced core game loops ensuring sustainable player progression and monetization conversion.',
        ua: 'Збалансував економічні цикли для довгострокового утримання гравців та монетизації.',
      },
    ],
  },
  {
    id: 'desktop-games',
    title: 'Board Game Club Administrator',
    company: 'Desktop Games',
    companyUrl: 'https://desktopgames.com.ua/ua/',
    timelineEn: 'June 2012 - November 2014 / Ukraine, Kyiv',
    timelineUa: 'Червень 2012 - Листопад 2014 / Україна, Київ',
    quickBullets: [
      { en: 'Board games club management', ua: 'Управління клубом настільних ігор' },
    ],
    roleEn:
      'Organized and hosted board game events and tournaments, explained complex game rule systems to diverse audiences, and built an enthusiastic gaming community.',
    roleUa:
      'Організація та проведення турнірів з настільних ігор, пояснення складних правил гравцям, адміністрування клубу та розвиток ігрової спільноти.',
    highlights: [
      {
        en: 'Deepened expertise in core game mechanics, rulebook architecture, and player psychology through tabletop gaming.',
        ua: 'Поглибив розуміння фундаментальних ігрових правил, архітектури механік та психології гравців.',
      },
    ],
  },
  {
    id: 'vabos',
    title: 'Hearing aid engineer',
    company: 'VABOS',
    companyUrl: 'http://vabos.kiev.ua/',
    timelineEn: 'October 2012 - October 2013 / Ukraine, Kyiv',
    timelineUa: 'Жовтень 2012 - Жовтень 2013 / Україна, Київ',
    quickBullets: [
      { en: 'Calculating directional characteristic', ua: 'Розрахунок характеристик направленості' },
      { en: 'Repair of hearing equipment', ua: 'Ремонт слухових апаратів' },
    ],
    roleEn:
      'Calculated acoustic directional characteristics of microphone arrays, calibrated micro-electronic audio equipment, and performed diagnostics and precision hardware repairs.',
    roleUa:
      'Розрахунок акустичних характеристик направленості мікрофонних систем, калібрування мікроелектронного аудіообладнання, діагностика та прецизійний ремонт слухових апаратів.',
    highlights: [
      {
        en: 'Applied acoustic engineering and signal processing theory to practical hardware calibration.',
        ua: 'Застосовував теорію акустичної інженерії та обробки сигналів для практичного калібрування апаратури.',
      },
    ],
  },
];

const WorkExperience = () => {
  const [expandedJobs, setExpandedJobs] = useState({});

  const allExpanded =
    EXPERIENCES.length > 0 && EXPERIENCES.every((job) => Boolean(expandedJobs[job.id]));

  const toggleJob = (id) => {
    setExpandedJobs((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleAll = () => {
    const nextState = !allExpanded;
    const updated = {};
    EXPERIENCES.forEach((job) => {
      updated[job.id] = nextState;
    });
    setExpandedJobs(updated);
  };

  // Keep newly rendered / expanded elements in sync with the current active language
  useEffect(() => {
    const checkbox = document.getElementById('checkbox-localize');
    const isUa = checkbox ? checkbox.checked : false;
    const container = document.getElementById('work-experience');

    if (container) {
      const textsEN = container.getElementsByClassName('text-EN');
      const textsUA = container.getElementsByClassName('text-UA');

      for (let i = 0; i < textsEN.length; i++) {
        textsEN[i].style.display = isUa ? 'none' : 'block';
      }
      for (let i = 0; i < textsUA.length; i++) {
        textsUA[i].style.display = isUa ? 'block' : 'none';
      }
    }
  }, [expandedJobs]);

  return (
    <div className="work-experiance" id="work-experience">
      <div className="exp-top-bar">
        <div className="sub-title text text-EN">Work Experience</div>
        <div className="sub-title text text-UA">Робочий досвід</div>

        <button
          type="button"
          className="exp-all-btn"
          onClick={toggleAll}
          aria-label="Toggle all work experience details"
        >
          <span className="text text-EN">
            {allExpanded ? 'Collapse All ▲' : 'Expand All ▼'}
          </span>
          <span className="text text-UA">
            {allExpanded ? 'Згорнути все ▲' : 'Розгорнути все ▼'}
          </span>
        </button>
      </div>

      {EXPERIENCES.map((job) => {
        const isExpanded = Boolean(expandedJobs[job.id]);

        return (
          <div key={job.id} className={`job-cont ${isExpanded ? 'is-expanded' : ''}`}>
            <div className="job-title">
              {job.title} /{' '}
              <a href={job.companyUrl} target="_blank" rel="noopener noreferrer">
                {job.company}
              </a>
            </div>

            <div className="job-timeline text text-EN">{job.timelineEn}</div>
            <div className="job-timeline text text-UA">{job.timelineUa}</div>

            {/* Quick summary bullets */}
            <ul className="job-exp-item">
              {job.quickBullets.map((bullet, bIdx) => (
                <React.Fragment key={bIdx}>
                  <li className="text text-EN">• {bullet.en}</li>
                  <li className="text text-UA">• {bullet.ua}</li>
                </React.Fragment>
              ))}
            </ul>

            {/* Expand / Collapse Button */}
            <button
              type="button"
              className="exp-toggle-btn"
              onClick={() => toggleJob(job.id)}
              aria-expanded={isExpanded}
            >
              <span className="text text-EN">
                {isExpanded ? 'Hide details ▲' : 'Show details ▼'}
              </span>
              <span className="text text-UA">
                {isExpanded ? 'Згорнути ▲' : 'Детальніше ▼'}
              </span>
            </button>

            {/* Expandable Details Drawer */}
            <div className={`job-details ${isExpanded ? 'expanded' : ''}`}>
              <div className="job-details-inner">
                {/* Role Overview */}
                {job.roleEn && (
                  <div className="job-detail-block">
                    <h4 className="job-details-heading text text-EN">
                      Role Overview & Responsibilities
                    </h4>
                    <h4 className="job-details-heading text text-UA">
                      Огляд ролі та обов'язки
                    </h4>
                    <p className="job-detail-text text text-EN">{job.roleEn}</p>
                    <p className="job-detail-text text text-UA">{job.roleUa}</p>
                  </div>
                )}

                {/* Projects */}
                {job.projects && job.projects.length > 0 && (
                  <div className="job-detail-block">
                    <h4 className="job-details-heading text text-EN">
                      Projects & Key Focus Areas
                    </h4>
                    <h4 className="job-details-heading text text-UA">
                      Проєкти та ключові напрямки
                    </h4>
                    <div className="job-projects-list">
                      {job.projects.map((proj, pIdx) => (
                        <div key={pIdx} className="job-project-card">
                          <div className="job-project-title">
                            {proj.link ? (
                              <a
                                href={proj.link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {proj.name} ↗
                              </a>
                            ) : (
                              <span>{proj.name}</span>
                            )}
                          </div>
                          <p className="job-project-desc text text-EN">
                            {proj.descEn}
                          </p>
                          <p className="job-project-desc text text-UA">
                            {proj.descUa}
                          </p>
                          {proj.tags && proj.tags.length > 0 && (
                            <div className="job-tags">
                              {proj.tags.map((tag, tIdx) => (
                                <span key={tIdx} className="job-tech-tag">
                                  {tag}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Highlights & Deliverables */}
                {job.highlights && job.highlights.length > 0 && (
                  <div className="job-detail-block">
                    <h4 className="job-details-heading text text-EN">
                      Key Deliverables & Achievements
                    </h4>
                    <h4 className="job-details-heading text text-UA">
                      Ключові результати та досягнення
                    </h4>
                    <ul className="job-highlights-list">
                      {job.highlights.map((h, hIdx) => (
                        <React.Fragment key={hIdx}>
                          <li className="text text-EN">• {h.en}</li>
                          <li className="text text-UA">• {h.ua}</li>
                        </React.Fragment>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WorkExperience;

